export default "__VITE_ASSET__BzL_tzuz__"